module.exports = __webpack_public_path__ + "static/media/blueberry.db842325.png";